import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import launcherIcon from "@app/neva/assets/neva_launcher.png";
import "./launcherIcon.scss";

export interface LauncherIconProps {
  handleClick: () => void;
}

const messages = defineMessages({
  widgetLauncherIcon: {
    id: "widgetLauncherIcon",
    defaultMessage: "Open Natera chat",
  },
});

const LauncherIcon: FC<LauncherIconProps> = ({ handleClick }) => {
  const intl = useIntl();
  return (
    <button
      className="launcher_icon__button"
      data-testid="launcher-icon"
      onClick={handleClick}
      id="widget-button"
    >
      <img
        className="launcher_icon"
        src={launcherIcon}
        alt={intl.formatMessage(messages.widgetLauncherIcon)}
      />
    </button>
  );
};

export default LauncherIcon;
